import { useQuery } from '@tanstack/react-query';
import { BASE_URL } from '../lib/api';

interface PublicFlags {
  private_beta: boolean;
  onboarding_demo: boolean;
}

async function fetchPublicFlags(): Promise<PublicFlags> {
  const res = await fetch(`${BASE_URL}/config/public-flags`);
  if (!res.ok) {
    throw new Error(`Failed to fetch public flags: ${res.status}`);
  }
  const body = await res.json() as PublicFlags;
  return body;
}

export function usePublicFlags() {
  const { data, isLoading } = useQuery({
    queryKey: ['public-flags'],
    queryFn: fetchPublicFlags,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  return {
    privateBeta: data?.private_beta ?? false,
    onboardingDemo: data?.onboarding_demo ?? false,
    isLoading,
  };
}
